// extracted by mini-css-extract-plugin
module.exports = {"page-banner":"pages_page-banner__yfMaQ","modal-video":"pages_modal-video__SmHuR"};